import { render, staticRenderFns } from "./exceptiondetail.vue?vue&type=template&id=2c698799&scoped=true"
import script from "./exceptiondetail.vue?vue&type=script&lang=js"
export * from "./exceptiondetail.vue?vue&type=script&lang=js"
import style0 from "./exceptiondetail.vue?vue&type=style&index=0&id=2c698799&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c698799",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c698799')) {
      api.createRecord('2c698799', component.options)
    } else {
      api.reload('2c698799', component.options)
    }
    module.hot.accept("./exceptiondetail.vue?vue&type=template&id=2c698799&scoped=true", function () {
      api.rerender('2c698799', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/complaintreporting/online/components/exceptiondetail.vue"
export default component.exports